import { FC } from 'react';

type Props = {
	className?: string;
};

const ChartBarLineIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M3.60156 12.3999V15.5998'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M10.0039 7.6001V15.5999'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M18.0036 18H2.00391'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M16.4023 10.8003V15.6002'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M4.88392 7.43984C4.59202 7.05125 4.1273 6.79991 3.60387 6.79991C2.72024 6.79991 2.00391 7.51624 2.00391 8.39987C2.00391 9.28354 2.72024 9.99984 3.60387 9.99984C4.48751 9.99984 5.20384 9.28354 5.20384 8.39987C5.20384 8.03967 5.08481 7.70726 4.88392 7.43984ZM4.88392 7.43984L8.7237 4.56001M8.7237 4.56001C9.01561 4.94859 9.48032 5.19994 10.0037 5.19994C10.6301 5.19994 11.1724 4.83999 11.4351 4.31565M8.7237 4.56001C8.52282 4.29259 8.40378 3.96018 8.40378 3.59997C8.40378 2.71633 9.12009 2 10.0037 2C10.8874 2 11.6037 2.71633 11.6037 3.59997C11.6037 3.85723 11.543 4.1003 11.4351 4.31565M11.4351 4.31565L14.9723 6.08422M14.9723 6.08422C14.8644 6.29957 14.8037 6.54265 14.8037 6.79991C14.8037 7.68354 15.52 8.39987 16.4036 8.39987C17.2873 8.39987 18.0036 7.68354 18.0036 6.79991C18.0036 5.91627 17.2873 5.19994 16.4036 5.19994C15.7772 5.19994 15.2349 5.55988 14.9723 6.08422Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
		</svg>
	);
};

export default ChartBarLineIcon;
